'use client';

import React from 'react';
import ImageToVectorTool from '@/components/tools/image-to-vector/ImageToVectorTool';

export default function ImageToVectorPage() {
  return <ImageToVectorTool />;
}
